interface AppTranslation {
  reference: string;
  id: string;
  appTextId: string;
  appTextReference: string;
  languageCode: string;
  value: string;
  isOptionSet: boolean;
  optionSetId?: string;
  optionSetKey?: string;
  optionSetValueId?: string;
  optionSetValueKey?: string;
}

export const getUpdatedTranslation = (
  appTranslation: AppTranslation,
  value: string,
): AppTranslation => {
  return {
    ...appTranslation,
    value: value,
  };
};

export default AppTranslation;
